import getClientApiRequestTransformer from '@/api/transformers/auth.request.transformer';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import getOrderCreatedTransformer from '@/api/transformers/notice/orderCreatedTransformer';
import clientApi from '@/apiClient';
import { AxiosResponse } from 'axios';

export default {
  async fetchInitForNewPlace(placeId: string): Promise<any> {
    return clientApi.get(`/place/switch/${placeId}`, {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getOrderCreatedTransformer(),
    })
      .then(({ data }: AxiosResponse<any>) => data);
  },
  async init(): Promise<any> {
    return clientApi.get('/init', {
      transformRequest: [
        ...getClientApiRequestTransformer,
        ...getSocketIdRequestTransformer,
      ],
      transformResponse: getOrderCreatedTransformer(),
    })
      .then(({ data }: AxiosResponse<any>) => data);
  }
};
